import React, { FC } from 'react'
import styled from 'styled-components'
import { Grid } from 'semantic-ui-react'
import { loadFont } from 'loankeeper-common/helpers/styles'
//@ts-ignore
import { GridContainer } from 'shared/StyledComponents'

import HistoryButton from '../shared/HistoryButton'
import ClientWarningMessages from '../shared/ClientWarningMessages'

const StyledGridContainer = styled(GridContainer)`
  position: relative;

  .modal-grid-container {
    height: 42px;
    padding: 4px 0px;
    vertical-align: middle;
    color: white;
  }

  .modal-grid-container .order-header-text {
    ${loadFont('16px Noto Serif SemiCondensed Bold')};
    margin-bottom: 0;
  }
`

const Header: FC<{
  heading: string
  form: string
  name: string
  OperTypeID: number
}> = ({ heading, form, name, OperTypeID }) => (
  <StyledGridContainer>
    {OperTypeID === 7 && <ClientWarningMessages FormName={form} />}

    <Grid className="modal-grid-container" style={{ backgroundColor: '#FF4746' }}>
      <Grid.Row>
        <Grid.Column width={2} />

        <Grid.Column width={12} textAlign="center" verticalAlign="middle">
          <p className="order-header-text">{heading}</p>
        </Grid.Column>

        <Grid.Column width={2} textAlign="right">
          <HistoryButton FormName={form} name={`${name}-historyModal`} />
        </Grid.Column>
      </Grid.Row>
    </Grid>
  </StyledGridContainer>
)

export default Header
